import { store } from "../store/index";

export const borderColor = localStorage.getItem("color");
export const buttonColor = localStorage.getItem("color");
export const themeColor = localStorage.getItem("color");
